import { Check } from 'lucide-react'
import type { SavedRecipeIngredient } from '../../lib/savedRecipeTypes'

type Props = {
  ingredient:    SavedRecipeIngredient
  isLast?:       boolean
  onToggleHasIt: (id: string, next: boolean) => Promise<void> | void
  onSubstitute?: () => void
}

export function RecipeIngredientRow({
  ingredient,
  isLast,
  onToggleHasIt,
  onSubstitute,
}: Props) {
  const { id, name, qtyLabel, hasIt, canSubstitute, manuallyMarked } = ingredient

  return (
    <div
      className={[
        'flex items-center gap-3 px-[14px] py-3',
        hasIt ? 'bg-paper' : 'bg-cream-warm',
        !isLast ? 'border-b border-border-hairline' : '',
      ].join(' ')}
    >
      <button
        onClick={() => onToggleHasIt(id, !hasIt)}
        aria-label={hasIt ? 'Mark as need' : 'Mark as have'}
        aria-pressed={hasIt}
        className={
          hasIt
            ? 'h-[22px] w-[22px] flex-shrink-0 rounded-full bg-forest flex items-center justify-center transition-colors'
            : 'h-[22px] w-[22px] flex-shrink-0 rounded-full border-[1.5px] border-terracotta bg-transparent transition-colors'
        }
      >
        {hasIt && <Check className="h-[11px] w-[11px] text-cream" strokeWidth={2.2} />}
      </button>

      <div className="flex-1 min-w-0">
        <div className="truncate font-serif text-[15px] font-medium text-ink tracking-[-0.01em] capitalize">
          {name}
        </div>
        <div
          className={
            hasIt
              ? 'mt-0.5 truncate text-[11px] italic text-forest'
              : 'mt-0.5 truncate text-[11px] italic text-terracotta'
          }
        >
          {hasIt ? 'You have it' : 'Need it'}
          {qtyLabel ? ` · ${qtyLabel}` : ''}
          {manuallyMarked && (
            <span className="text-ink-muted"> · marked manually</span>
          )}
        </div>
      </div>

      {!hasIt && canSubstitute !== false && onSubstitute && (
        <button
          onClick={onSubstitute}
          className="font-serif text-[11px] italic text-ink-muted whitespace-nowrap px-1"
        >
          sub?
        </button>
      )}
    </div>
  )
}
